import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { Meta } from '@angular/platform-browser';

import * as models from './shared/models';
import * as fromRootStore from './store';
import { MenuActionFeatureDisableAccessories, MenuActionFeatureDisableLocalSpecials,MenuActionFeatureDisableApplyForCredit,MenuActionEnableApplyForCredit } from './store/actions/menu.action';
import { EnvironmentConfiguration } from './environment/services/environment.configuration';
import { TokenService } from './services/api/token.service';
import { LoaderService } from './services/common/loader.service';

@Component({
  selector: 'dd-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

  isLoading$: Observable<boolean>;
  // Observable to save inventory screen data
  sharedDataStore$: Observable<models.SharedData>;
  // Subscriber for Shared Data Store
  sharedDataStoreSubscriber: any;
  // Field to store Shared Data from store
  sharedData: models.SharedData = <models.SharedData>{};
  title = 'rti-customer-ui';

  constructor ( public _store: Store<fromRootStore.IAppState>,
                public meta: Meta,
                private environment: EnvironmentConfiguration,
                private loaderService: LoaderService,
                private _tokenService: TokenService) {

    this.isLoading$ = this.loaderService.isLoading$;
    this.sharedDataStore$ = _store.select(fromRootStore.SharedDataStore);

    const wafScript = this.initScript(`${environment.WAF_URL}challenge.js`);

    wafScript.onload = () => {
      this.loadGoogleMaps();
    };
  }

  ngOnInit() {
    console.log('environment:', this.environment['envName']);
    this.sharedDataStoreSubscriber = this.sharedDataStore$.subscribe(data => {
      // console.log('SHARED DATA REDUCER: ' + JSON.stringify(data));
      this.sharedData = Object.assign({}, data);
    });

    this._store.select(fromRootStore.FeatureConfigStore).subscribe(data => {
      const shared = Object.assign({}, data, {
        items: data.items
      });
      this._store.dispatch(new
        MenuActionFeatureDisableAccessories(
          shared.items.filter(item => item.name.toLowerCase() === 'vspec-web-dio'
            && item.active === true).length === 0));
      this._store.dispatch(new
        MenuActionFeatureDisableApplyForCredit(
          shared.items.filter(item => item.name.toLowerCase() === 'vspec-web-creditapp'
            && item.active === true).length === 0));
      this._store.dispatch(new
        MenuActionEnableApplyForCredit(true));
      this._store.dispatch(new
        MenuActionFeatureDisableLocalSpecials(
          shared.items.filter(item => item.name.toLowerCase() === 'vspec-web-localspecials'
            && item.active === true).length === 0));
    });
  }

  private initScript(url: string): HTMLScriptElement {
    const scriptToAppend: HTMLScriptElement = document.createElement('script');
    scriptToAppend.src = url;
    scriptToAppend.defer = true;
    scriptToAppend.async = true;
    document.querySelector('head').appendChild(scriptToAppend);

    return scriptToAppend;
  }

  private loadGoogleMaps() {
    this._tokenService.getGoogleMapsToken()
      .subscribe(
        (res: any) => {
          let googleKey = '';
          if (res && res.tokenDetails && res.tokenDetails.apiKey) {
            googleKey = res.tokenDetails.apiKey;
            const googleMapsScript = this.initScript(`https://maps.googleapis.com/maps/api/js?key=${googleKey}`);
            googleMapsScript.onload = () => {
              this._tokenService.isMapLoaded$.next(true);
            }
          } else {
            this._tokenService.isMapLoadedError$.next(true);
          }
        },
        (error: any) => {
          console.error('Error getting Google Maps token:', error);
        }
    );
  }

  ngOnDestroy() {
    if (this.sharedDataStoreSubscriber) {
      this.sharedDataStoreSubscriber.unsubscribe();
    }
  }

}
